
import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import ApplicationTypeTable from "./ApplicationTypeTable.vue"
import DuplicateTypeTable from "./DuplicateTypeTable.vue";
import EndorsementTypeTable from "./EndorsementTypeTable.vue";
import { ApplicationViewModel, DuplicableDocumentModel, DuplicableDocumentModelDocumentType, PaymentViewModel, StartApplyingOrChangeTypeClient, StateFeeRequirementViewModel } from "@/api-client";
import { BCollapse } from "bootstrap-vue";
import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";

interface Props {
    seafarerId: string;
    application: ApplicationViewModel;
}

@Component({
    components: {
        ApplicationTypeTable,
        DuplicateTypeTable,
        EndorsementTypeTable,
        CardQuicklink,
        BCollapse
    }

})
export default class ChangeApplicationType extends Vue implements Props {
    @Prop({ required: true })
    seafarerId!: string;
    @Prop({ required: true })
    application!: ApplicationViewModel;

    stateFeerequirementFulfillment = this.application.requirementFulfillments.find(w => w.requirement instanceof StateFeeRequirementViewModel);

    duplicableDocuments: DuplicableDocumentModel[] | null = null;
    documentTypes = {
        certificate: DuplicableDocumentModelDocumentType.Certificate,
        endorsement: DuplicableDocumentModelDocumentType.Endorsement
    }

    async created() {
        this.duplicableDocuments = await new StartApplyingOrChangeTypeClient().duplicableDocuments(this.seafarerId);
    }

    get paid() {
        return (this.stateFeerequirementFulfillment?.requirementValue as PaymentViewModel)?.isConfirmed;
    }

    get sum() {
        return (this.stateFeerequirementFulfillment?.requirement as StateFeeRequirementViewModel).sum;
    }

}
